export const expenseNumberOriginal = ({ theme: { dimensions } }) => ({
    maxWidth: dimensions.inputMediumMaxWidth,
});
